"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_top_tabs_1 = require("@react-navigation/material-top-tabs");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const header_1 = require("../../../components/header");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const Basic_1 = __importDefault(require("../../../networking/apis/Basic"));
const Home_1 = __importDefault(require("../../../networking/apis/Home"));
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const HashTagArticle_1 = __importDefault(require("./components/HashTagArticle"));
const ProfileFollow_1 = __importDefault(require("./components/ProfileFollow"));
const TimeLine_1 = __importDefault(require("./components/TimeLine"));
const styles_1 = __importDefault(require("./styles"));
const CustomTabBar = ({ state, descriptors, navigation, tabBarOptions, }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.tabContainer, tabBarOptions.style] },
        react_1.default.createElement(react_native_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, contentContainerStyle: { flexDirection: 'row' } }, state.routes.map((route, index) => {
            const { options } = descriptors[route.key];
            const isFocused = state.index === index;
            const label = options.tabBarLabel !== undefined ? options.tabBarLabel : route.name;
            return (react_1.default.createElement(react_native_1.TouchableOpacity, { key: index, onPress: () => navigation.navigate(route.name), style: styles_1.default.tab, activeOpacity: 1 },
                react_1.default.createElement(CustomText_1.default, { weight: isFocused ? '600' : '300', style: [
                        styles_1.default.tabLabel,
                        { color: isFocused ? '#007AFF' : '#888888' },
                    ] }, label),
                react_1.default.createElement(react_native_1.View, { style: {
                        width: '100%',
                        height: (0, scale_1.scale)(4),
                        backgroundColor: '#DDDDDD',
                    } }, isFocused && (react_1.default.createElement(react_native_1.View, { style: {
                        width: '100%',
                        height: (0, scale_1.scale)(4),
                        backgroundColor: '#007AFF',
                        borderRadius: 99,
                    } })))));
        }))));
};
const TotalHashtag = () => {
    const [count, setCount] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const listener = new react_native_1.NativeEventEmitter().addListener(constants_1.listenerEvents.TOTAL_HASHTAG_DETAIL, (total) => {
            setCount(total);
        });
        return () => {
            listener.remove();
        };
    }, []);
    return (react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
            fontSize: (0, scale_1.moderateScale)(11),
            lineHeight: (0, scale_1.moderateScale)(19),
            color: '#7C7C7C',
            paddingVertical: (0, scale_1.scale)(8),
        } }, `${count}件`));
};
const Tab = (0, material_top_tabs_1.createMaterialTopTabNavigator)();
const HashtagDetailScreen = (props) => {
    const { typeScreen = 1, hashtag, typeHashTag = 1 } = props.route?.params;
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const [dataCallApi, setDataCallApi] = (0, react_1.useState)([]);
    const [checkFolow, setCheckFolow] = (0, react_1.useState)(true);
    const [index, setIndex] = (0, react_1.useState)(0);
    const screenTitle = `#${decodeURIComponent(hashtag)}`;
    const isAnonymous = myProfile?.registration_status == 0;
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigation = (0, native_1.useNavigation)();
    (0, react_1.useEffect)(() => {
        const focusTab = navigation.addListener('focus', (_e) => {
            if (typeScreen == 0 && typeHashTag == 2) {
                navigation.navigate(Routes_1.default.history);
            }
            else if (typeScreen == 0 && typeHashTag == 3) {
                navigation.navigate(Routes_1.default.timeline);
            }
            else if (typeScreen == 0 && typeHashTag == 4) {
                // e.preventDefault() // Ngăn chặn việc xóa tab
                navigation.navigate(Routes_1.default.profile);
            }
        });
        return focusTab;
    }, [navigation, typeHashTag]);
    (0, react_1.useEffect)(() => {
        if (connected) {
            callApiHashTagArticle();
        }
    }, [connected]);
    const callApiHashTagArticle = async () => {
        try {
            const res = await Home_1.default.HashTagArticle({ page: 1, type: 1, hashtag: hashtag });
            setDataCallApi(res.data);
            setCheckFolow(res?.data?.is_followed == 0);
        }
        catch (error) {
        }
        finally {
        }
    };
    const callApiFollowHashTag = async () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        Basic_1.default.followHashTag(dataCallApi?.hash_tag_id)
            .then(() => {
            // dispatch(appSlice.actions.showToast(`${hashtag}さんをフォローしました`))
            setCheckFolow(false);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => { });
    };
    const callApiUnFollowHashTag = async () => {
        Basic_1.default.unFollowHashTag(dataCallApi?.hash_tag_id)
            .then(() => {
            // dispatch(appSlice.actions.showToast(`${hashtag}さんをフォロー解除しました`))
            setCheckFolow(true);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => { });
    };
    const titleHeader = () => {
        switch (typeScreen) {
            case 0:
                return screenTitle;
            case 1:
            case '1':
                return `記事: #${decodeURIComponent(hashtag)}`;
            case 2:
            case '2':
                return `自分史: #${decodeURIComponent(hashtag)}`;
            case 3:
            case '3':
                return `タイムライン: #${decodeURIComponent(hashtag)}`;
            case 4:
            case '4':
                return `プロフィール: #${decodeURIComponent(hashtag)}`;
            default:
                return screenTitle;
        }
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: { backgroundColor: '#F7F7F7', flex: 1 } },
        react_1.default.createElement(header_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: '\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#21242D' }), onLeftPress: () => {
                if (index != 0) {
                    (0, rootNavigation_1.goBack)();
                }
                (0, rootNavigation_1.goBack)();
            } }),
        react_1.default.createElement(react_native_1.View, { style: {
                width: (0, scale_1.scale)(343),
                marginHorizontal: (0, scale_1.scale)(16),
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: (0, scale_1.scale)(10),
                marginBottom: (0, scale_1.scale)(10),
            } },
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    width: '100%',
                    fontSize: (0, scale_1.moderateScale)(18),
                    lineHeight: (0, scale_1.moderateScale)(27),
                    textAlign: 'center',
                } }, screenTitle),
            react_1.default.createElement(TotalHashtag, null),
            checkFolow ? (react_1.default.createElement(components_1.BorderButton, { style: {
                    width: '100%',
                    height: (0, scale_1.scale)(30),
                }, title: '\u30D5\u30A9\u30ED\u30FC', onPress: callApiFollowHashTag })) : (react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                    width: '100%',
                    height: (0, scale_1.scale)(30),
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: (0, scale_1.scale)(3),
                    backgroundColor: '#DDDDDD',
                }, onPress: callApiUnFollowHashTag },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: '#545454',
                    } }, "\u30D5\u30A9\u30ED\u30FC\u4E2D")))),
        typeScreen == 0 ? (react_1.default.createElement(Tab.Navigator, { key: hashtag, tabBar: (props) => (react_1.default.createElement(CustomTabBar, { ...props, tabBarOptions: {
                    scrollEnabled: true,
                    tabStyle: { width: 'auto' },
                    indicatorStyle: { backgroundColor: 'blue' },
                    style: {},
                } })) },
            react_1.default.createElement(Tab.Screen, { name: "article", component: HashTagArticle_1.default, initialParams: { type: 1, hashtag: decodeURIComponent(hashtag) }, listeners: () => ({
                    focus: () => {
                        setIndex(0);
                    },
                }), options: {
                    tabBarLabel: '記事',
                } }),
            react_1.default.createElement(Tab.Screen, { name: "history", component: HashTagArticle_1.default, initialParams: { type: 2, hashtag: decodeURIComponent(hashtag) }, options: {
                    tabBarLabel: '自分史',
                }, listeners: () => ({
                    focus: () => {
                        setIndex(1);
                    },
                }) }),
            react_1.default.createElement(Tab.Screen, { name: "timeline", component: TimeLine_1.default, initialParams: { hashtag: decodeURIComponent(hashtag) }, options: {
                    tabBarLabel: 'タイムライン',
                }, listeners: () => ({
                    focus: () => {
                        setIndex(2);
                    },
                }) }),
            react_1.default.createElement(Tab.Screen, { name: "profile", component: ProfileFollow_1.default, initialParams: { hashtag: decodeURIComponent(hashtag) }, options: {
                    tabBarLabel: 'プロフィール・フォロー',
                }, listeners: () => ({
                    focus: () => {
                        setIndex(3);
                    },
                }) }))) : null,
        typeScreen == 1 && react_1.default.createElement(HashTagArticle_1.default, { type: 1, hashtag: decodeURIComponent(hashtag) }),
        typeScreen == 2 && react_1.default.createElement(HashTagArticle_1.default, { type: 2, hashtag: decodeURIComponent(hashtag) }),
        typeScreen == 3 && react_1.default.createElement(TimeLine_1.default, { hashtag: decodeURIComponent(hashtag) }),
        typeScreen == 4 && react_1.default.createElement(ProfileFollow_1.default, { hashtag: decodeURIComponent(hashtag) })));
};
exports.default = HashtagDetailScreen;
